import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {GoBiz} from './goBizWidget';
import {GoBizValueProp} from './goBizValueProp';
import ChromeNotification from './ChromeNotification';

// import { connect } from 'react-redux';
// import { Link } from 'react-router';

class Header extends Component {
  static propTypes = {
    location: PropTypes.object,
    gocashInfo: PropTypes.object,
    userInfo: PropTypes.object,
    showLoginPopUp: PropTypes.bool,
    showGobiz: PropTypes.bool,
    showWebenagageNotification: PropTypes.bool,
    webengageTitle: PropTypes.string,
    actions: PropTypes.object,
  };

  static defaultProps = {
    location: {
      pathname: '',
    },
    gocashInfo: {},
    userInfo: {},
    showGobiz: false,
    showLoginPopUp: false,
    showWebenagageNotification: false,
    webengageTitle: 'Web push opt-in prompt',
    action: {
      updateProfileType: () => {},
    },
  };

  constructor(props) {
    super(props);
    this.loginHandler = this.loginHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.closeLogInPopUp = this.closeLogInPopUp.bind(this);
    this.handleGocashView = this.handleGocashView.bind(this);
    this.handleBusinessProfileType = this.handleBusinessProfileType.bind(this);
    this.toggleBusinessFormState = this.toggleBusinessFormState.bind(this);
    this.closeBusinessForm = this.closeBusinessForm.bind(this);
    this.state = {
      showLoginComponent: false,
      showRegisterComponent: false,
      showBusinessCreateForm: false,
      showGoBizValueProp: false,
    };
  }

  componentDidMount() {
    this.handleGocashView();
  }

  componentDidUpdate() {
    this.handleGocashView();
  }

  handleGocashView() {
    const {gocashInfo} = this.props;
    const gocashBalance = gocashInfo && gocashInfo.data ? gocashInfo.data.t_amt : 0;

    if (this.refs && this.refs.gocashDiv && this.refs.gocashView) {
      if (gocashBalance > 0 && gocashBalance <= 2000) {
        this.refs.gocashDiv.href = '/refer-earn/';
        this.refs.gocashDiv.classList.remove('vh');
        this.refs.gocashView.innerHTML = 'Earn credits';
      } else if (gocashBalance >= 2000) {
        this.refs.gocashDiv.href = '/gocash/view/';
        this.refs.gocashDiv.classList.remove('vh');
        this.refs.gocashView.innerHTML = 'Your credits';
      } else {
        this.refs.gocashDiv.href = '/info/gocash-benefits/';
        this.refs.gocashDiv.classList.remove('vh');
        this.refs.gocashView.innerHTML = 'Earn credits';
      }
    }
  }

  toggleBusinessFormState(successFlag, type) {
    if (!successFlag && type === 'business') {
      this.setState({showBusinessCreateForm: true});
    } else if (successFlag && type === 'business') {
      this.setState({showGoBizValueProp: true});
    } else {
      this.setState({showBusinessCreateForm: false, showGoBizValueProp: false});
    }
  }

  handleBusinessProfileType(type) {
    const setProfile =
      '/profiles/business/v1.0/set_business_profile_in_session/?type=' + type + '&flavour=v2';
    axios
      .get(setProfile)
      .then(response => {
        const responseData = response.data;
        const {updateProfileType} = this.props.actions;
        updateProfileType(responseData.profile_type);
        this.toggleBusinessFormState(responseData.success, type);
      })
      .catch(err => {
        console.log('Set Business profile API call failed');
        console.trace(err);
      });
  }

  closeBusinessForm() {
    this.setState({showBusinessCreateForm: false, showGoBizValueProp: false});
  }

  loginHandler(event) {
    const {showLoginPopUp} = this.props;
    if (showLoginPopUp) {
      this.setState({showLoginComponent: true});
      document.querySelector('body').classList.add('oh');
    } else {
      event.target.setAttribute(
        'href',
        '/accounts/login/?next=' + window.location.href.replace('http://', 'https://'),
      );
    }
  }

  registerHandler(event) {
    const {showLoginPopUp} = this.props;
    if (showLoginPopUp) {
      this.setState({showRegisterComponent: true});
      document.querySelector('body').classList.add('oh');
    } else {
      event.target.setAttribute(
        'href',
        '/accounts/register/?next=' + window.location.href.replace('http://', 'https://'),
      );
    }
  }

  closeLogInPopUp() {
    this.setState({showLoginComponent: false, showRegisterComponent: false});
    document.querySelector('body').classList.remove('oh');
  }

  // <Link to="/hotelsn/"> <i className="icon-hotels db blue ico28 lh1-2 padT2 padB3"></i> <span className="iconText">Hotels</span> </Link>
  render() {
    const {
      gocashInfo = {},
      userInfo = {},
      location,
      showGobiz,
      showLoginPopUp,
      showWebenagageNotification,
      webengageTitle,
      actions,
    } = this.props;
    const {showLoginComponent, showRegisterComponent} = this.state;
    const {pathname} = location;
    const gocashAmount = gocashInfo && gocashInfo.data ? gocashInfo.data.t_amt : 0;
    const {profile_type = 'personal'} = userInfo;
    const url =
      showLoginPopUp && (showLoginComponent || showRegisterComponent)
        ? encodeURIComponent(window.location.href)
        : '';
    return (
      <div>
        <div className="headerBox col-md-12 col-sm-12 col-xs-12" id="header">
          {/* login pop up component */}
          {(showLoginPopUp && (showLoginComponent || showRegisterComponent) && (
            <div>
              <div className="popOverlay popShow" onClick={this.closeLogInPopUp}></div>
              <div id="authOverlay" className="popModal zoom small popShow">
                <div className="popContent">
                  <a
                    className="fr icon-close font12Lt popClose"
                    href="javascript:void(0)"
                    onClick={this.closeLogInPopUp}
                  ></a>
                  <div className="popBody">
                    <iframe
                      id="authiframe"
                      src={
                        '/accounts/' +
                        (showRegisterComponent ? 'register' : 'login') +
                        '/?iframe=1&next=' +
                        url
                      }
                      width="100%"
                      height="480px"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          )) ||
            ''}
          <div className="col-md-8 col-sm-8 col-xs-6 pad0 marginT5">
            <a href="/" className="hdrLogo">
              <img src="https://goibibo.ibcdn.com/styleguide/images/goLogo.png" />
            </a>
            <ul className="mainLinks">
              <li className={pathname.startsWith('/flights/') || pathname === '/' ? 'active' : ''}>
                <a href="/flights/">
                  <i className="icon-flights db blue ico24 lh1-2 padT5 padB5"></i>
                  <span className="iconText ">Flights</span>
                </a>
              </li>
              <li className={pathname.startsWith('/hotels/') ? 'active' : ''}>
                <a href="/hotels/">
                  <i className="icon-hotels db blue ico28 lh1-2 padT2 padB3"></i>
                  <span className="iconText ">Hotels</span>
                </a>
              </li>
              <li className={pathname.startsWith('/gostays/') ? 'active' : ''}>
                <a href="/gostays/">
                  <i className="icon-gostays icon-gostays-cstm db blue padT5 padB5"></i>
                  <span className="iconText ">Hotels</span>
                </a>
              </li>
              <li
                className={
                  pathname.startsWith('/bus/') || pathname.startsWith('/sbus/') ? 'active' : ''
                }
              >
                <a href="/sbus/">
                  <i className="icon-bus db blue ico24 lh1-2 padT5 padB5"></i>
                  <span className="iconText ">Bus</span>
                </a>
              </li>
              <li className={pathname.startsWith('/trains/') ? 'active posRel' : 'posRel'}>
                <a href="/trains/">
                  {/* <i className="icon-train-front-view db blue ico24 lh1-2 padT5 padB5"></i> */}
                  <img
                    src="https://goibibo.ibcdn.com/styleguide/images/train_logo.png"
                    width="24px"
                    height="25px"
                    className="marginT5 marginB5"
                    alt="irctc train logo"
                  />
                  <span className="iconText ">IRCTC Trains</span>
                </a>
              </li>
              <li className={'posRel' + (pathname.startsWith('/cars/') ? ' active' : '')}>
                <a href="/cars/">
                  <i className="icon-airport-transfer db blue ico24 lh1-2 padT5 padB5"></i>
                  <span className="iconText ">Cabs</span>
                </a>
              </li>
              <li className={pathname.startsWith('/visa/') ? 'active posRel' : 'posRel'}>
                <a href="/visa/">
                  <i className="icon-visa1 db blue ico24 lh1-2 padT5 padB5"></i>
                  <span className="hdrOfferTag">
                    <span className="hdrOfferTxt">NEW!</span>
                  </span>
                  <span className="iconText ">Visa</span>
                </a>
              </li>
              {/* <li className="posRel hdrHolidayLink">
                          <a href="/activity/">
                            <i className="icon-activities db blue ico24 lh1-2 padT5 padB5"></i>
                            <span className="hdrOfferTag"><span className="hdrOfferTxt">NEW!</span></span>
                            <span className="iconText ">Activities</span>
                          </a>
                        </li>
                         <li className={pathname.startsWith('/holidays/') ? 'active posRel' : 'posRel'}>
                          <a href="//holiday.goibibo.com/lead/form/">
                            <i className="icon-holidays db blue ico24 lh1-2 padT5 padB5"></i>
                            <span className="hdrOfferTag">
                              <span className="hdrOfferTxt">NEW!</span>
                            </span>
                            <span className="iconText ">Holidays</span>
                          </a>
                        </li>
                        <li className={pathname.startsWith('/go/f/') ? 'active posRel' : 'posRel'}>
                            <a className="" href="/go/f/">
                                <i className="icon-go-packages ico26 blue db marginT5 padT2 padB5"></i>
                                <span className="iconText">Flight + Hotels</span>
                            </a>
                        </li> */}
              <li className="hdrMoreLink">
                <div className="padB10 lh1-2 iconText fmtTooltip">
                  more +
                  <div className="tip tip_top white moreSubLinks">
                    <a href="/international-flights/">
                      <i className="icon-flights padR10 blue ico20 fl"></i>
                      <span className="fl padT3">International Flights</span>
                    </a>
                    {/* <a href="https://holiday.goibibo.com" target="_blank" className="width100">
                              <i className="icon-holidays padR10 blue ico20 fl"></i>
                              <span className="fl padT3">Holidays</span>
                            </a>
                            <a href="/events/" className="width100">
                              <i className="icon-passbook padR10 blue ico20 fl"></i>
                              <span className="fl padT3">Events</span>
                            </a> */}
                    <a href="/mobile/">
                      <i className="icon-mobiles padR10 blue ico20 fl"></i>
                      <span className="fl padT3">Mobile Apps</span>
                    </a>
                    <a href="/destinations/">
                      <i className="icon-destination ico22 fl padR10"></i>
                      <span className="fl padT5">Destinations</span>
                    </a>
                    <a href="/ask/">
                      <i className="icon-ask ico22 fl padR10"></i>
                      <span className="fl padT5">Ask</span>
                    </a>
                    <a href="/routeplanner/">
                      <i className="icon-route-planner padR10 blue ico20 fl"></i>
                      <span className="fl padT3">Route Planner</span>
                    </a>
                    <a href="/offers/">
                      <i className="icon-offer-badge padR10 blue ico20 fl"></i>
                      <span className="fl padT3">Offers &amp; Promotions</span>
                    </a>
                    {/* <a href="/coupons/">
                              <i className="icon-gift-card padR10 blue ico20 fl"></i>
                              <span className="fl padT3">GO5000 Offers</span>
                            </a> */}
                    <a href="/review-and-rating/">
                      <i className="icon-photo-review padR10 blue ico22 fl"></i>
                      <span className="fl padT3">Reviews &amp; Ratings</span>
                    </a>
                    <a href="/trains/check-train-running-status/">
                      <i className="icon-train-front-view ico22 fl padR10"></i>
                      <span className="fl padT5">Train Runing Status</span>
                    </a>
                    <a href="/trains/check-pnr-status/">
                      <i className="icon-train-front-view ico22 fl padR10"></i>
                      <span className="fl padT5">Check PNR Status</span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-4 col-sm-4 col-xs-6 fr pad0 txtRight">
            <span className="width100 fl txtRight padB5 padR5">
              <a className="hdrCusSupport padR10 vMid" href="/support/">
                <small className="fl ico13 lh1-2 vMid">
                  <span className="txtCente dib"> 24x7 goCare Support</span>
                </small>
              </a>

              <span
                id="hdr_user_signin"
                className={
                  (gocashInfo && gocashInfo.data ? 'dn' : 'dib') + ' txtRight hdrUserName vMid'
                }
                ref="hdr_user_signin"
              >
                <span className="ico13 blue db">
                  <a id="get_sign_in" onClick={this.loginHandler}>
                    Sign In
                  </a>
                  <span>/</span>
                  <a id="get_sign_up" onClick={this.registerHandler}>
                    Sign up
                  </a>
                </span>
              </span>
            </span>
            <div className="dib padR15 vMid mobdn">
              <a href="/info/gotribe-launching-soon/">
                <img
                  src="https://gos3.ibcdn.com/gotripe-coming-soon2x-1599021706.png"
                  alt=""
                  width="84px"
                  height="36px"
                />
              </a>
            </div>
            {(showGobiz && (
              <div className="headerGST mobdn">
                <div className="gstTabs">
                  <a
                    href="javascript:void(0)"
                    onClick={this.handleBusinessProfileType.bind(this, 'personal')}
                    className={
                      'tabs ' +
                      (profile_type === undefined || profile_type === 'personal' ? 'active' : '')
                    }
                  >
                    <span className="ico12">Personal</span>
                  </a>
                  <a
                    href="javascript:void(0)"
                    onClick={this.handleBusinessProfileType.bind(this, 'business')}
                    className={'tabs last ' + (profile_type === 'business' ? 'active' : '')}
                  >
                    <span className="ico12">Business</span>
                  </a>
                </div>
              </div>
            )) ||
              ''}
            <a
              href="/refer-earn/"
              className="dib hdrgoCash padR15 vMid mobdn marginT2"
              ref="gocashDiv"
            >
              <span className="db">
                <span className="availGocash">
                  <img
                    src="https://goibibo.ibcdn.com/styleguide/images/goCash-header.png"
                    width="23px"
                    height="23px"
                    className="fl"
                  />
                  <span className="fl">
                    <span className="fl padB4 blue fmed textOverflow padL5 padT3">
                      <span className="icon-rupee ico12 fl padT3"></span>
                      <span className="fl ico16" id="gocashTotal">
                        {gocashAmount}
                      </span>
                    </span>
                  </span>
                </span>
              </span>
              <span
                className="fl ico13 lh1-2 padL5 posRel width100 txtCenter padT2"
                ref="gocashView"
              ></span>
            </a>
            <div id="hd_user_widdget" className="fmtTooltip hdrUser vMid" ref="hd_user_widdget">
              <div className="userPhoto">
                <i className="fl icon-user blue ico30 padT5 padL5"></i>
                <span className="goBizLogoHdr"></span>
              </div>
              <div className="tip tip_top right white moreSubLinks">
                <ul>
                  <li>
                    <a href="/support/">My Trips</a>
                  </li>
                  <li>
                    <a href="/support/">View Ticket</a>
                  </li>
                  <li>
                    <a href="/support/">Cancel Ticket</a>
                  </li>
                  <li>
                    <a href="/support/">Make Payment</a>
                  </li>
                  <li>
                    <a href="/support/">Check Refund Status</a>
                  </li>
                  <li>
                    <a href="/contactus/">Write to us</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="hdrMobMoreLinks">
              <a className="fl ico24 blue" href="#">
                <i className="mobMenu fl icon-menu1 blue ico20"></i>
              </a>
              <ul className="mobMoreMenu">
                <li>
                  <a href="/#search">Flight Booking</a>
                </li>
                <li>
                  <a href="#">Hotels Booking</a>
                </li>
                <li>
                  <a href="#">Bus Booking</a>
                </li>
                <li>
                  <a href="//holiday.goibibo.com/lead/form/">Holiday Booking</a>
                </li>
                <li>
                  <a href="/offers/">Offers &amp; Promotions</a>
                </li>
                <li>
                  <a href="/support/">Customer Support</a>
                </li>
              </ul>
            </div>
          </div>
          {(this.state.showBusinessCreateForm && <GoBiz close={this.closeBusinessForm} />) || ''}
          {(this.state.showGoBizValueProp && <GoBizValueProp close={this.closeBusinessForm} />) ||
            ''}
        </div>
        {(showWebenagageNotification && <ChromeNotification webengageTitle={webengageTitle} />) ||
          ''}
      </div>
    );
  }
}

// function HeaderState(state) {
//     return {
//         gocashInfo: state.common.gocashInfo
//     };
// }

export default Header;
